/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * One-click theme preset that sets all color and config defaults
 * @export
 */
export const SurfaceThemePreset = {
    DARK_GAMING: 'DARK_GAMING',
    BRAND_MINIMAL: 'BRAND_MINIMAL',
    NEON_CYBERPUNK: 'NEON_CYBERPUNK',
    MILITARY_TACTICAL: 'MILITARY_TACTICAL',
    LIGHT_CLEAN: 'LIGHT_CLEAN'
} as const;
export type SurfaceThemePreset = typeof SurfaceThemePreset[keyof typeof SurfaceThemePreset];


export function instanceOfSurfaceThemePreset(value: any): boolean {
    for (const key in SurfaceThemePreset) {
        if (Object.prototype.hasOwnProperty.call(SurfaceThemePreset, key)) {
            if (SurfaceThemePreset[key as keyof typeof SurfaceThemePreset] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SurfaceThemePresetFromJSON(json: any): SurfaceThemePreset {
    return SurfaceThemePresetFromJSONTyped(json, false);
}

export function SurfaceThemePresetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceThemePreset {
    return json as SurfaceThemePreset;
}

export function SurfaceThemePresetToJSON(value?: SurfaceThemePreset | null): any {
    return value as any;
}

export function SurfaceThemePresetToJSONTyped(value: any, ignoreDiscriminator: boolean): SurfaceThemePreset {
    return value as SurfaceThemePreset;
}

